import { openDialog } from '@/dialog'

export type UserCardMode = 'profile' | 'employee'
export type UserCardContext = 'profile' | 'list' | 'admin'

export interface AssignmentHistoryItem {
  id: number | string
  position: string
  department: string
  period: string
  orderNumber: string
  type: string
  isCurrent: boolean
}

export interface UserCardDialogData {
  userId: number | string
  mode?: UserCardMode
  context?: UserCardContext
  title?: string
  assignmentHistory?: AssignmentHistoryItem[]
  vacationTotal?: number | string
}

type OpenUserCardOptions = {
  userId: number | string
  mode?: UserCardMode
  context?: UserCardContext
  title?: string
  cb?: (..._args: any[]) => any
}

const openUserCardDialog = ({
  userId,
  mode = 'employee',
  context,
  title,
  cb,
}: OpenUserCardOptions) => {
  const resolvedContext = context || (mode === 'profile' ? 'profile' : 'list')
  const canEdit = resolvedContext === 'admin'
  const canSubmit = canEdit || resolvedContext === 'profile'

  return openDialog({
    name: 'UserCard',
    action: canSubmit ? 'update' : 'view',
    dialogData: {
      userId,
      mode,
      context: resolvedContext,
      title,
    },
    params: {
      title,
      cb,
      hideActionButtons: !canSubmit,
      cancelLabel: 'Скасувати',
      submitLabel: 'Зберегти',
    },
  })
}

export { openUserCardDialog }
